// extracted by mini-css-extract-plugin
export default {"bodyBox":"index_bodyBox_Ex8w0"};